export default function Phase5() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Phase Header */}
        <div className="flex items-center justify-center mb-8">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160517458/settings_images/c821fd2-60ad-dfbb-b7b-3c7076dbb748_0a9554db-dfc8-42b5-bbf2-fe0e7fe8eafe.png" 
            alt="Phase Icon" 
            className="w-16 h-16"
          />
        </div>

        <div className="max-w-4xl mx-auto text-left mb-12">
          <h4 className="text-xl font-bold text-gray-900 mb-2">
            <span>Phase 4:</span>
          </h4>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            <span>AI Content Planning &amp; Scriptwriting</span>
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/0a2adf8-53cd-a3e5-1a3d-c05e20b836e_Ai_content_planning.png" 
              alt="AI Content Planning" 
              className="w-full mb-6 rounded-lg"
            />
            <h5 className="text-xl font-bold text-gray-900 mb-4">
              <span><strong>AI Content Planning</strong></span>
            </h5>
            <ul className="text-left space-y-3 text-base text-gray-700">
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Plan an entire month of content in under 30 minutes</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Use AI to reverse-engineer what's working in your niche</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Build a content calendar that actually aligns with your goals</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Organize your ideas and track performance with your personal AI assistant</span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/806757-f25a-c768-505-aebc435cf2d7_Ai_scriptwriting.png" 
              alt="AI Scriptwriting" 
              className="w-full mb-6 rounded-lg"
            />
            <h5 className="text-xl font-bold text-gray-900 mb-4">
              <span><strong>AI Scriptwriting</strong></span>
            </h5>
            <ul className="text-left space-y-3 text-base text-gray-700">
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>The exact prompt templates we use to write full YouTube scripts</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Train AI to study your competitors and write like a pro</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Structure videos that retain attention and deliver value fast</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Write for Reels, Shorts, and TikTok using short-form-specific AI workflows</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
